export default __webpack_public_path__ + "static/media/Construction.f5249458.svg";